import React from 'react'
import { PixAprovado, PixCancelado, PixError, PixNaoAprovado, PixPendente } from './StatesPix'
import { IoChevronBackOutline } from 'react-icons/io5'
import { CheckoutContext } from '../../../contexts/CheckoutContext'
import RouterHook from '../../../contexts/RouterHook'
import { Loading } from '../../Simple'

import './stylesPix.css'

export default function DeskPix() {
  const serverRouter = RouterHook()
  const { sttCtxChkt, loadCh } = React.useContext(CheckoutContext)

  return (
    <div className='contain-page-pix' style={loadCh.pix ? { height: 'calc(100% - 15px)', maxHeight: '500px' } : {}}>
      <IoChevronBackOutline className='btt-back-page' onClick={() => serverRouter('back')} />
      {loadCh.pix ? (
        <div className='contain-loading'>
          <Loading text={'Carregando dados do pagamento...'} />
        </div>
      ) : sttCtxChkt.modePix === 'pendente' ? (
        <PixPendente />
      ) : sttCtxChkt.modePix === 'aprovado' ? (
        <PixAprovado />
      ) : sttCtxChkt.modePix === 'cancelado' ? (
        <PixCancelado />
      ) : sttCtxChkt.modePix === 'nao_aprovado' ? (
        <PixNaoAprovado />
      ) : (
        <PixError />
      )}
    </div>
  )
}
